<!-- @format -->

<ng-container *ngIf="isMobileView; then mobileBreadcrumbs; else largeBreadcrumbs"></ng-container>
<ng-template #mobileBreadcrumbs>
	<div
		class="col-12 breadcrumbs product-breadcrumbs"
		itemprop="breadcrumb"
		itemscope=""
		itemtype="http://schema.org/BreadcrumbList">
		<span
			itemprop="itemListElement"
			itemscope=""
			itemtype="http://schema.org/ListItem"
			*ngIf="breadcrumbs === undefined || (breadcrumbs && breadcrumbs.length === 1)">
			<a
				class="breadcrumb-link"
				href="/"
				itemprop="item">
				<span itemprop="name">Home </span>
				<meta
					itemprop="position"
					content="1" />
			</a>
		</span>
		<span
			itemprop="itemListElement"
			itemscope=""
			itemtype="http://schema.org/ListItem"
			*ngIf="breadcrumbs !== undefined && breadcrumbs.length > 1">
			<a
				class="breadcrumb-link"
				href="{{ breadcrumbs[breadcrumbs.length - 2].url }}"
				itemprop="item">
				<span
					itemprop="name"
					*ngIf="breadcrumbs[breadcrumbs.length - 2].note"
					>{{ breadcrumbs[breadcrumbs.length - 2].note }}</span
				>
				<span
					itemprop="name"
					*ngIf="!breadcrumbs[breadcrumbs.length - 2].note"
					>{{ breadcrumbs[breadcrumbs.length - 2].name }}</span
				>
				<meta
					itemprop="position"
					content="1" />
			</a>
		</span>
	</div>
</ng-template>
<ng-template #largeBreadcrumbs>
	<div
		class="col-12 breadcrumbs product-breadcrumbs"
		itemprop="breadcrumb"
		itemscope=""
		itemtype="http://schema.org/BreadcrumbList">
		<span
			itemprop="itemListElement"
			itemscope=""
			class="home-link"
			itemtype="http://schema.org/ListItem">
			<a
				class="breadcrumb-link"
				href="/"
				itemprop="item"
				id="WC_BreadCrumb_Link_1">
				<span
					id="breadCrumb_Link_1"
					itemprop="name"
					>Home
				</span>
				<meta
					itemprop="position"
					content="1" />
			</a>
		</span>
		<span
			itemprop="itemListElement"
			itemscope=""
			itemtype="http://schema.org/ListItem"
			*ngFor="let breadcrumb of breadcrumbs; index as i; last as last; trackBy: trackByFn">
			<a
				class="breadcrumb-link"
				id="WC_BreadCrumb_Link_{{ i + 2 }}"
				*ngIf="!last"
				href="{{ breadcrumb.url }}"
				itemprop="item">
				<i class="">|</i>
				<span
					itemprop="name"
					id="breadCrumb_Link_{{ i + 2 }}"
					*ngIf="breadcrumb.note"
					>{{ breadcrumb.note }}</span
				>
				<span
					itemprop="name"
					id="breadCrumb_Link_{{ i + 2 }}"
					*ngIf="!breadcrumb.note"
					>{{ breadcrumb.name }}</span
				>
				<meta
					itemprop="position"
					content="{{ i + 2 }}" />
			</a>
			<span
				class="breadcrumb-link current-page"
				itemprop="item"
				*ngIf="last">
				<i class="">|</i>
				<span
					itemprop="name"
					*ngIf="breadcrumb.note"
					>{{ breadcrumb.note }}</span
				>
				<span
					itemprop="name"
					*ngIf="!breadcrumb.note"
					>{{ breadcrumb.name }}</span
				>
				<meta
					itemprop="position"
					content="{{ i + 2 }}" />
			</span>
		</span>
	</div>
</ng-template>
